import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CompanyConfiguration } from '@app-config/models/company-configuration';

import { DateConstants } from '@core-constants/dates/date.constants';
import { ListingDetailsSectionName } from '@listings/enums/listing-details-section-name';
import { ListingDetailsNavigationParams } from '@listings/models/events/listing-details-navigation-params';
import { ListingInfo } from '@listings/models/listing/listing-info';
import { OpenHouse } from '@listings/models/listing/openhouse';
import { MediaViewerInitialParams } from '@media/components/media-viewer/models/media-viewer-initial-params';
import { GalleryListingCardComponent } from '../../../view-modules/view-base/components/gallery-listing-card/gallery-listing-card.component';
import { RpcIconComponent } from '../../../core-modules/utils/rpc-icon/rpc-icon.component';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'landing-open-house-card',
    templateUrl: './landing-open-house-card.component.html',
    styleUrls: ['./landing-open-house-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GalleryListingCardComponent, RpcIconComponent, DatePipe]
})
export class LandingOpenHouseCardComponent {
    @Input() public listing: ListingInfo;
    @Input() public openHouse: OpenHouse;
    @Input() public shouldHideOpenRentals: boolean;
    @Input() companyConfiguration: CompanyConfiguration;

    @Output() public mediaViewerClicked = new EventEmitter<MediaViewerInitialParams>();
    @Output() public listingDetailsClicked = new EventEmitter<ListingDetailsNavigationParams>();

    public readonly dateConstants = DateConstants;

    public onMediaViewerClicked(mediaViewerClickedEventParams: MediaViewerInitialParams): void {
        this.mediaViewerClicked.emit(mediaViewerClickedEventParams);
    }

    public onOpenHouseCardClicked(): void {
        this.listingDetailsClicked.emit({ listingId: this.listing.id, tabId: ListingDetailsSectionName.OpenHouses });
    }
}
